<template>
  <input x-text-field
    type="text"
    v-bind="{...$attrs, value}"
    v-on="{
      ...$listeners,
      input: v=>$emit('input',v.target.value),
    }"

    :class="{
      w100p,
      'centered-input': 'center' in $attrs,
    }"

    :reverse="'right' in $attrs"
    :id="v_id"

    />
    <!-- :id="'vm__' + this.$vnode.data.model.expression.replace('.', '__')" -->
</template>

<style>
.w100p { width: 100% }
.centered-input input {
  text-align: center
}

/* 개발모드에서는 필요 없지만 build 하고 나면 사라지기 때문에 필수!  */
.imd-sm-input input { line-height: 20px; }

/* -- imd-input-mask ----------------------------------------------------- */
input.imd-input-mask {
  border: 1px solid #c2c2c2 !important;
  padding:2px;
  border-radius: 4px !important;
  background: #fff;
}
.imd-input-mask:hover {
  border:1px solid #000000 !important;
  border-radius: 4px !important;
}
.imd-input-mask:focus:not([disabled="disabled"]),
.imd-input-mask:active:not([disabled="disabled"]){
  border:1px solid #1976d2 !important;
  border-radius: 4px !important;
  outline: 1px solid #1976d2 !important;
}
input.imd-input-mask.imd-sm-input[disabled="disabled"] {
  border: 1px solid #c2c2c2 !important;
  padding:0px;
  border-radius: 4px !important;
  background: #EFEFEF !important;
  height: 23px;
}

/* -- imd-input-mask ----------------------------------------------------- */


</style>

<script>

// import {mask} from 'vue-the-mask'
// import InputSet from './mixin/input-set';
export default {
  inheritAttrs: false,
  // directives: {mask},
  // mixins: [ InputSet ],
  // props: ['value'],
  props: {
    value: [String, Number, Object, Array],
    w100p: { type: Boolean, default: false },
  },
  watch: {
    // value(n) {
    //   if (this.value === undefined) { // clear()시 호출됨.
    //     this.$emit("input", "")
    //   }
    // }
  },
  computed: {
    v_id() {
      return this.$vnode.data.model && 'input-'+this.$vnode.data.model.expression || 'v'
    }
  },
  methods: {
    // focus() {
    //   this.$nextTick(() => this.$el.getElementsByTagName("input")[0].focus())  // 확인에 자동 포커스
    // }
  },
}
</script>